export default __webpack_public_path__ + "static/media/frutiger-45light.105ffe8d.svg";